import React, { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./constants/msAuthConfig";
import { AuthProvider } from "./components/customHooks/useAuth";

const AppRouter = lazy(() => import('./routes/routes'))

const pca = new PublicClientApplication(msalConfig);

const App = () => {
  const { t } = useTranslation();
  return (
    <MsalProvider instance={pca}>
      <Router>
        <AuthProvider>
          <Suspense fallback={<div className={'text-center mt-3'}>{t('loadingPlsWait')}</div>} >
            <AppRouter />
          </Suspense>
        </AuthProvider>
      </Router >
    </MsalProvider>
  );
}

export default App;